declare var $: any;

export default function rightClickDisabled() {
(function() {
    // 右クリック禁止
    $(document).bind("contextmenu",function(e){
        return false;
    });
}());
}